export default __webpack_public_path__ + "static/media/036-tv.70322f84.svg";